export const TOOL_IMAGE_PREVIEW_LIMIT = 5;

export interface ToolImagePreviewItem {
  id?: string | number;
  title?: string | null;
  thumbnailUrl?: string | null;
  optimizedUrl?: string | null;
}

function isToolImagePreviewItem(value: unknown): value is ToolImagePreviewItem {
  return !!value && typeof value === 'object';
}

export function parseToolImagePreviewOutput(output: unknown): {
  images: ToolImagePreviewItem[];
  hasMore: boolean;
} {
  if (!output || typeof output !== 'object') {
    return { images: [], hasMore: false };
  }

  const imagesValue = (output as { images?: unknown }).images;
  if (!Array.isArray(imagesValue)) {
    return { images: [], hasMore: false };
  }

  const images = imagesValue.filter(isToolImagePreviewItem);
  const payload = output as { count?: unknown; hasMore?: unknown };
  const reportedCount = typeof payload.count === 'number' ? payload.count : images.length;
  const reportedHasMore = payload.hasMore === true;

  return {
    images,
    hasMore: reportedHasMore || reportedCount > images.length || images.length > TOOL_IMAGE_PREVIEW_LIMIT,
  };
}
